import { Component, Input, OnInit } from '@angular/core';
import { CommonService, DocumentService, SharedVarService } from '@school/a2z-lib';

@Component({
  selector: 'school-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input('headingvalue') headingtext: any;
  constructor(
    private _userService: CommonService,
    private _docService: DocumentService,
    private SharedVarservice: SharedVarService) { }

  ngOnInit(): void {
    this.getStaffDetails();


    this.SharedVarservice.getValue().subscribe((value: any) => {

      if (typeof (value) == 'string') {
        if (value == 'hospital_updates') {
          this.getStaffDetails();
        }
      }

    });

  }



  hospital_name: string;
  hospital_address: any;
  hospital_logo: string;
  getStaffDetails(): void {

    this._userService.getLoginUserInfos().subscribe(
      result => {
        this.hospital_name = result.body.data.hospital_name;
        this.hospital_address = result.body.data.hospital_address;
        this.getLogo();
      }, error => {
        console.log(error);
      });
  }


  getLogo(): void {

    if (this.hospital_address.logo) {

      let path = this.hospital_address.logo.file_path;

      this._docService.getFileUrl(path).subscribe((response) => {

        this.hospital_logo = response.body.data.url;

      });

    }
  }

}
